export const ReactTableAction = {
  TOGGLE_ALL_ROWS_SELECTED: 'toggleAllRowsSelected',
  TOGGLE_ROW_SELECTED: 'toggleRowSelected',
  TOGGLE_ALL_PAGE_ROWS_SELECTED: 'toggleAllPageRowsSelected'
};
